import React from 'react'
import Modal, { Header } from 'src/components/theme/Models/Modal'
import FormContext from './FormContext'
import FormSuspense from 'src/components/Forms/FormSuspense'
import Form from './Form'

interface AddModalProps {
  isOpen: boolean
  toggle: () => void
  staffingAgency: string
}

const AddModal: React.FC<AddModalProps> = (props) => {
  const { isOpen, toggle, staffingAgency } = props

  return (
    <Modal
      title='Add POC'
      isOpen={isOpen}
      toggle={toggle}
    >
      <Header title='Add POC' />
      <FormSuspense fallback={<Form toggle={toggle} disableSave />}>
        <FormContext toggle={toggle} staffingAgency={staffingAgency} />
      </FormSuspense>
    </Modal>
  )
}

export default AddModal
